import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/icons/user-bold-duotone.svg'


const _withScopeId = n => (_pushScopeId("data-v-392f0364"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Mes Parrainages", -1))
const _hoisted_2 = { class: "d-flex w-100 justify-content-end" }
const _hoisted_3 = {
  class: "d-flex bg-primary p-3",
  style: {"height":"60px","border-radius":"10px","flex":"none"}
}
const _hoisted_4 = { style: {"font-size":"1.5em","font-weight":"500","color":"antiquewhite"} }
const _hoisted_5 = { class: "mt-3 rounded-2 overflow-hidden d-flex flex-column bg-white px-3 py-2" }
const _hoisted_6 = ["id"]
const _hoisted_7 = {
  key: 0,
  id: "loader-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_table = _resolveComponent("b-table")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_b_container = _resolveComponent("b-container")!

  return (_openBlock(), _createBlock(_component_b_container, null, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, "Solde : " + _toDisplayString(_ctx.solde) + " CFA", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_b_table, {
          "head-variant": "light",
          fields: _ctx.fields,
          "current-page": _ctx.currentPage,
          id: "my-table",
          "tbody-transition-props": _ctx.transProps,
          "sticky-header": "",
          hover: "",
          items: _ctx.fileuls
        }, {
          "cell(id)": _withCtx((data) => [
            _createElementVNode("img", {
              class: "img-fluid",
              style: {"height":"40px"},
              id: data.item.id,
              src: _imports_0,
              alt: ""
            }, null, 8, _hoisted_6)
          ]),
          _: 1
        }, 8, ["fields", "current-page", "tbody-transition-props", "items"]),
        _createVNode(_component_b_pagination, {
          class: "align-self-end mt-3",
          modelValue: _ctx.currentPage,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentPage) = $event)),
          "total-rows": _ctx.rows(),
          "per-page": _ctx.perPage,
          "aria-controls": "my-table"
        }, null, 8, ["modelValue", "total-rows", "per-page"])
      ]),
      (_ctx.isloading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_Loading)
          ]))
        : _createCommentVNode("", true)
    ], undefined, true),
    _: 1
  }))
}